import React from 'react';
import { AiOutlineCalendar, AiOutlineShoppingCart, AiOutlineAreaChart, AiOutlineBarChart, AiOutlineStock } from 'react-icons/ai';
import { FiShoppingBag, FiEdit, FiPieChart, FiBarChart, FiCreditCard, FiStar, FiShoppingCart } from 'react-icons/fi';
import { BsKanban, BsBarChart, BsBoxSeam, BsCurrencyDollar, BsShield, BsChatLeft } from 'react-icons/bs';
import { BiColorFill } from 'react-icons/bi';
import { IoMdContacts } from 'react-icons/io';
import { RiContactsLine, RiStockLine } from 'react-icons/ri';
import { MdOutlineSupervisorAccount } from 'react-icons/md';
import { HiOutlineRefresh } from 'react-icons/hi';
import { TiTick } from 'react-icons/ti';
import { GiLouvrePyramid } from 'react-icons/gi';
import { GrLocation } from 'react-icons/gr';


// src/api/users.js or wherever you place API functions

export const users_data = async () => {
  try {
    const response = await fetch(
      'https://mbricks-webapp-fkfuchcyfqdxg5ey.centralus-01.azurewebsites.net/api/users',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch users data: ${response.status}`);
    }

    const data = await response.json();

    // ✅ Map the response to match users_data_1 format
    const transformed = data.map((user) => ({
      UserId: user.UserId,
      Email: user.Email,
      CreatedAt: user.CreatedAt,
      Status: user.Status
    }));

    return transformed;
  } catch (error) {
    console.error('Error fetching users data:', error);
    return [];
  }
};


export const users_data_1 = async () => {
  // Instead of fetching from the API, return 5 rows of mock data
  return [
    {
      UserId: 'U001',
      Email: 'alice@example.com',
      CreatedAt: '2025-10-01',
      Status: 'Active',
    },
    {
      UserId: 'U002',
      Email: 'bob@example.com',
      CreatedAt: '2025-09-15',
      Status: 'Inactive',
    },
    {
      UserId: 'U003',
      Email: 'carol@example.com',
      CreatedAt: '2025-08-28',
      Status: 'Active',
    },
    {
      UserId: 'U004',
      Email: 'dave@example.com',
      CreatedAt: '2025-10-02',
      Status: 'Pending',
    },
    {
      UserId: 'U005',
      Email: 'eve@example.com',
      CreatedAt: '2025-09-05',
      Status: 'Suspended',
    },
  ];
};
